import { CloseOutlined } from '@ant-design/icons';
import AppButton from '@nxsys/components/AppButton';
import AppFormContainer from '@nxsys/components/AppFormContainer';
import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { Form, Typography } from 'antd';
import { FormProps } from 'antd/lib';
import React from 'react';
import AppRateInput from '@nxsys/components/AppRateInput';

export type EarningStatementFilterValues = {
  taxPeriod?: number;
  year?: number;
};

type EarningStatementFilterProps = {
  isOpen: boolean;
  toggle: () => void;
  onFilter: (values: EarningStatementFilterValues) => void;
};

const EarningStatementFilterModal: React.FC<EarningStatementFilterProps> = ({
  isOpen,
  toggle,
  onFilter,
}) => {
  const { messages } = useTypedIntl();
  const [form] = Form.useForm();
  const watchValue = Form.useWatch([], form);
  const ableToClearFilter =
    watchValue && Object.keys(watchValue).some((key) => !!watchValue[key]);

  const handleClearAll = (e: React.MouseEvent) => {
    e.stopPropagation();
    form.resetFields();
  };

  const onFinish: FormProps['onFinish'] = (values) => {
    onFilter({
      taxPeriod: values.taxPeriod ? Number(values.taxPeriod) : undefined,
      year: values.year ? Number(values.year) : undefined,
    });
    toggle();
  };

  const onFinishFailed: FormProps['onFinishFailed'] = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <AppModalContainer
      title={messages['common.filter']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.apply'],
          buttonType: 'primary',
          onClick: () => form.submit(),
        },
      ]}
      closeIcon={
        <div style={{ marginRight: 90 }}>
          <AppButton
            name={messages['common.clearAll']}
            leftIcon={<CloseOutlined />}
            onClick={handleClearAll as any}
            disabled={!ableToClearFilter}
          />
        </div>
      }
      minHeight="200px"
    >
      <AppFormContainer
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        layout="vertical"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
      >
        <Typography.Text>{messages['common.taxPeriod']}</Typography.Text>
        <div className="grid grid-cols-1 gap-x-4 mt-2">
          <Form.Item name="taxPeriod">
            <AppRateInput
              placeholder={messages['common.enterTaxPeriod'] || 'Enter tax period'}
            />
          </Form.Item>
        </div>
        <Typography.Text>{messages['common.taxYear']}</Typography.Text>
        <div className="grid grid-cols-1 gap-x-4 mt-2">
          <Form.Item name="year">
            <AppRateInput
              placeholder={messages['common.enterTaxYear'] || 'Enter tax year'}
            />
          </Form.Item>
        </div>
      </AppFormContainer>
    </AppModalContainer>
  );
};

export default EarningStatementFilterModal;
